"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconChevronUp = void 0;
const react_1 = __importDefault(require("react"));
const Icon_1 = require("./Icon");
// Material Icon
// https://material.io/resources/icons/?search=up&icon=keyboard_arrow_up&style=baseline
const IconChevronUp = (props) => {
    return (react_1.default.createElement(Icon_1.SVGIcon, { ...props, size: props.size },
        react_1.default.createElement("path", { d: "M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z" }),
        react_1.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" })));
};
exports.IconChevronUp = IconChevronUp;
